import { Flex } from "@mantine/core";
import { useMemo } from "react";
import { withErrorBoundary } from "react-error-boundary";

import { CallControlsManager } from "@/call-controls";
import { isVoiceTask, useActiveTask } from "@/sdk";
import { useLogger } from "@/sdk/logging/LoggerProvider";
import { createFallbackRender } from "@/shared-utils";

export function WorkspaceContentTopbarSlot() {
    const logger = useLogger({ module: "Workspace" });

    const CallControlsManagerHandled = useMemo(
        () =>
            withErrorBoundary(CallControlsManager, {
                fallbackRender: createFallbackRender(logger),
            }),
        [logger],
    );

    const activeTask = useActiveTask();
    const activeVoiceTask = useMemo(() => {
        return isVoiceTask(activeTask) ? activeTask : null;
    }, [activeTask]);

    return (
        <Flex pos={"absolute"} inset={0}>
            <CallControlsManagerHandled voiceTask={activeVoiceTask} />
        </Flex>
    );
}
